<script setup lang="ts">
type Size = "md" | "lg" | "xl";

withDefaults(
  defineProps<{
    placeholder?: string;
    ariaLabel?: string;
    size?: Size;
    loading?: boolean;
    highlight?: boolean;
  }>(),
  {
    placeholder: undefined,
    ariaLabel: undefined,
    size: "xl",
    loading: false,
    highlight: false,
  }
);

const model = defineModel<string>({ default: "" });

const { t } = useI18n();

function clear() {
  model.value = "";
}
</script>

<template>
  <UInput v-model="model" :placeholder="placeholder" :aria-label="ariaLabel ?? placeholder" :size="size" :highlight="highlight">
    <template #trailing="{ ui }">
      <AppSpinner v-if="loading" :class="[ui.trailingIcon(), 'size-5 md:size-6', { 'p-0.5': ['lg', 'xl'].includes(size) }]" />
      <UButton
        v-else-if="model"
        square
        variant="ghost"
        class="shrink-0 p-2 -mr-2"
        size="sm"
        :aria-label="t('ui.search.clear')"
        @mousedown.prevent="clear"
      >
        <UIcon name="icon:close" :class="ui.trailingIcon()" />
      </UButton>
      <UIcon v-else name="icon:search" :class="ui.trailingIcon()" />
    </template>
  </UInput>
</template>
